var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("footer", { staticClass: "footer" }, [
      _c("div", { staticClass: "container-fluid" }, [
        _c("div", { staticClass: "copyright text-center" }, [
          _vm._v("\n      © 2020 Ingram Micro Inc. All Rigths reserved.\n    ")
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }